import { render } from "./Terapist.vue?vue&type=template&id=5208ff10"
import script from "./Terapist.vue?vue&type=script&lang=js"
export * from "./Terapist.vue?vue&type=script&lang=js"

import "./Terapist.vue?vue&type=style&index=0&id=5208ff10&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__